import { Box, FormHelperText, TextField, Typography } from "@mui/material";
import React from "react";
import { ITheme } from "../../utils/theme";
import CharacterCount from "../CharacterCount";

interface NumericInputProps {
  value: number | null;
  onChange?: (value: string) => void;
  label: string;
  maxLength?: number;
  required?: boolean;
  readOnly?: boolean;
  error?: JSX.Element | string;
  disabled?: boolean
}

export const NumericInput: React.FC<NumericInputProps> = ({
  value,
  onChange,
  label,
  maxLength,
  required = false,
  readOnly = false,
  error = false,
  disabled = false
}) => (
  <Box sx={{ mb: maxLength ? '-16px' : 0 }}>
    <Typography variant='form-label' sx={{ fontWeight: 'normal' }}>
      {label}
      <Typography component={"span"} sx={{ color: (theme: ITheme) => theme.palette.red.A700, ml: 0.5 }}>*</Typography>
    </Typography>
    <TextField
      error={!!error}
      fullWidth
      value={value}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      inputProps={{
        maxLength,
        readOnly,
        inputMode: 'numeric',
        pattern: '[0-9]*'
      }}
      className={readOnly ? 'readonly' : ''}
      required={required}
      disabled={disabled}
    />
    {maxLength && !error && <CharacterCount currentLength={(value?.toString().length || 0)} maxLength={maxLength} />}
    {error && <FormHelperText
      component={'div'}
      error={!!error}
    >
      {error}
    </FormHelperText>}
  </Box>
);
